import { useState } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import { message } from 'antd';
import { createElectronicInvoice } from 'services/invoices';
import { AddNewInvoceFormCustomError } from 'types';

import useTranslation from '../../customHooks/translate';
import CustomDialog from './CustomDialog';

interface InvoiceDetails {
  invoiceId: number;
  qaimeNo: number;
  qaimeDate: string;
}

const AddNewInvoiceForm = (props) => {
  const { id: invoiceId } = useParams();
  const translation = useTranslation();

  const [invoiceNoError, setInvoiceNoError] = useState<string | null>(null);
  const [invoiceDateError, setInvoiceDateError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [invoiceDetails, setInvoiceDetails] = useState({} as InvoiceDetails);

  const setOnValueChange = (value, name) => {
    setInvoiceDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCreateInvoice = () => {
    setLoading(true);
    const payload = {
      ...invoiceDetails,
      invoiceId: Number(invoiceId),
    };
    createElectronicInvoice(payload)
      .then(() => {
        message.success(`${translation.messages.successAdded}`);
        props.handleClose();
      })
      .catch((error: AddNewInvoceFormCustomError) => {
        error.response?.data?.Message &&
          message.error(error.response?.data?.Message);
        const errorMessageInvoiceNo = error.response?.data.errors?.QaimeNo as
          | string
          | undefined;
        const errorMessageInvoiceDate = error.response?.data.errors
          ?.QaimeDate as string | undefined;
        const generalErrorMessage = error.response?.data?.Message || null;
        generalErrorMessage?.length && message.error(generalErrorMessage);
        setInvoiceNoError(errorMessageInvoiceNo || null);
        setInvoiceDateError(errorMessageInvoiceDate || null);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleCreateInvoice();
  };

  return (
    <CustomDialog
      open={props.open}
      handleClose={props.handleClose}
      buttonTitle={translation.electronicInvoice.ConfirmButton}
      isLoading={loading}
      title={translation.electronicInvoice.Header}
      onSubmit={handleCreateInvoice}
    >
      <form onSubmit={handleSubmit} className="flex flex-col gap-[20px]">
        <div className="flex flex-col gap-[12px]">
          <label className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
            {translation.electronicInvoice.LabelText} *
          </label>

          <Input
            className="d-block"
            type="text"
            id="qaimeNo"
            maxLength={30}
            minLength={3}
            onChange={(event) =>
              setOnValueChange(event?.target?.value, 'qaimeNo')
            }
            placeholder="123456"
            value={invoiceDetails?.qaimeNo}
            style={{
              borderColor: invoiceNoError ? 'red' : '',
            }}
          />
          {invoiceNoError && (
            <span className="text-[12px] text-red-600">{invoiceNoError}</span>
          )}
        </div>
        <div className="flex flex-col gap-[12px]">
          <label className="text-[14px] font-semibold text-[#1D1D1D] md:text-[16px]">
            {translation.electronicInvoice.LabelDateText} *
          </label>
          <Input
            onChange={(event) => {
              setOnValueChange(event?.target?.value, 'qaimeDate');
            }}
            value={invoiceDetails?.qaimeDate}
            id="qaimeDate"
            type="date"
            style={{
              borderColor: invoiceDateError ? 'red' : '',
            }}
          />
          {invoiceDateError && (
            <span className="text-[12px] text-red-600">{invoiceDateError}</span>
          )}
        </div>
      </form>
    </CustomDialog>
  );
};

export default AddNewInvoiceForm;

const Input = styled.input`
  width: 100%;
  border-radius: 6px;
  padding: 12.7px 15px;
  border: 1px solid rgba(41, 45, 50, 0.25);
  :focus {
    outline: none !important;
    border: 2px solid #466afb;
    padding: 11.9px 14px;
  }
`;
